import { render, staticRenderFns } from "./iama.vue?vue&type=template&id=43be8ef9"
import script from "./iama.vue?vue&type=script&lang=js"
export * from "./iama.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports